import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { FilterDashboard } from "../types/types";
import { formatNumberWithLetters } from "../components/charts";
import { DASHBOARD_FILTER_CRITERIA } from "../../witadmin/Common/constants";
import { IConfig, useConfig } from "../../../lib/config";
import { useKeycloakAuthz } from "../../../components/keycloak-provider";

export const isMoneyFilterCriteria = ({ criteria }) =>
  criteria.labelName === DASHBOARD_FILTER_CRITERIA.BY_CHECKIN_DATE ||
  criteria.labelName === DASHBOARD_FILTER_CRITERIA.BY_CHECKOUT_DATE;

interface useGetDashboardProps {
  criteria: FilterDashboard;
  start: string;
  end: string;
  propertyTicker: string;
}

type reservationInfo = {
  count: number;
  day: string;
  averageAmount: number;
  totalAmount: number;
};

export const useGetDashboard = ({ criteria, start, end, propertyTicker }: useGetDashboardProps) => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  const configuration: IConfig = useConfig();
  const keycloak = useKeycloakAuthz()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.post(`${configuration.dashboardUrl}/${propertyTicker}`, {
          criteria: criteria.value.toUpperCase(),
          start,
          end,
        }, {
          headers: {
            Authorization: keycloak.rpt,
          }
        });
        const currentYear = data.reservationInfo.currentYear.map((item: reservationInfo) => {
          const data = isMoneyFilterCriteria({ criteria }) ? item.totalAmount : item.count;
          const formattedNumber = formatNumberWithLetters(data);
          return {
            x: dayjs(item.day).format("DD/MM"),
            y: data,
            formattedY: formattedNumber,
            fullDate: dayjs(item.day).format("DD/MM/YYYY"),
          };
        });
        const pastYear = data.reservationInfo.pastYear.map((item: reservationInfo) => {
          const data = isMoneyFilterCriteria({ criteria }) ? item.totalAmount : item.count;
          const formattedNumber = formatNumberWithLetters(data);
          return {
            x: dayjs(item.day).format("DD/MM"),
            y: data,
            formattedY: formattedNumber,
            fullDate: dayjs(item.day).format("DD/MM/YYYY"),
          };
        });

        setData({
          currentYear,
          pastYear,
        });
      } catch (error) {
        console.log("Error in dashboard", error);
      }
      setLoading(false);
    };

    if (start && end && criteria?.value) {
      setLoading(true);
      fetchData();
    }
  }, [configuration.dashboardUrl, criteria, start, end, propertyTicker, keycloak]);

  return { data, loading };
};
